export default {
	Choose: 'Choose',
	image: 'image',
	sound: 'sound',
	video: 'video',
	file: 'file',
	media: 'media',
	Reset: 'Reset Default',
	map: 'map',
	noOptions: 'Sorry but you can\'t use Media form field because you didn\'t configure it. Please read the documentation',
};
